/* eslint-disable no-nested-ternary */
import React from "react";

import { getStoryTrendPath, StoryTrendLink } from "app/links";

import { classnames, Icon } from "@culturehq/components";

import { isTarget } from "app/utils";
import Accordian from "components/common/Accordian";
import { TargetQuoteIcon } from "components/common/icons";
import PromptIcon from "./PromptIcon";

const QuestionTitle = ({ children, className, showLink, storyQuestion }) => {
  if (showLink) {
    return (
      <StoryTrendLink className={className} storyQuestion={storyQuestion}>
        {children}
        {storyQuestion.question}
      </StoryTrendLink>
    );
  }

  return (
    <>
      {children}
      {storyQuestion.question}
    </>
  );
};

const Subprompt = ({ showLink, storyQuestion }) => (
  <div className="Subprompt-Container">
    <QuestionTitle
      className="Subprompt-Title"
      showLink={showLink}
      storyQuestion={storyQuestion}
    >
      <Icon className="Subprompt-Arrow" icon="nested-element" />
      <PromptIcon allowedTypes={storyQuestion.allowedTypes} />
    </QuestionTitle>
  </div>
);

const StoryQuestionTitle = ({ orgName, storyQuestion, showLink, showAccordian }) => {
  if (storyQuestion.storyQuestionType === "child_prompt" && showAccordian) {
    return (
      <Accordian
        className={classnames("FeedItem__preview__title__Story", { ParentPrompt: storyQuestion.storyQuestionType === "child_prompt" })}
        icon="quote"
        title={storyQuestion.parentStoryQuestion.question}
        initialOpen
        orgName={orgName}
        titleLink={
          showLink ? getStoryTrendPath(null, storyQuestion.parentStoryQuestion) : undefined
        }
        upDown
      >
        {storyQuestion.storyQuestionType === "child_prompt" && <Subprompt showLink={showLink} storyQuestion={storyQuestion} />}
      </Accordian>
    );
  }

  return (
    <div className={classnames("FeedItem__preview__title__Story", { ParentPrompt: storyQuestion.storyQuestionType === "child_prompt" })}>
      <h1 className="Title">
        {isTarget(orgName) ? (
          <TargetQuoteIcon className="TargetQuoteIcon" />
        ) : (
          <Icon className="quote-icon" icon="quote" />
        )}
        <QuestionTitle
          showLink={showLink}
          storyQuestion={storyQuestion.storyQuestionType === "child_prompt" ? storyQuestion.parentStoryQuestion : storyQuestion}
        />
      </h1>
      {storyQuestion.storyQuestionType === "child_prompt" && <Subprompt showLink={showLink} storyQuestion={storyQuestion} />}
    </div>
  );
};

export default StoryQuestionTitle;
